import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';

const equalNumbersRegex = /^(\d)\1+$/;
const postalCodeRegex = /^\d\d\d\d\d-\d\d\d$/;
const emailRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
const phoneRegex = /^[0-9() \-+]{8,20}$/;
const addressRequiredFields = ['postalCode', 'line1', 'number', 'district', 'city', 'state'];
const foreignAddressRequiredFields = [
  'postalCode',
  'line1',
  'number',
  'countryCode',
  'city',
  'state',
];

export function required(value) {
  if (Array.isArray(value)) {
    return value.length > 0 ? undefined : <FormattedMessage id="required" />;
  }
  return value ? undefined : <FormattedMessage id="required" />;
}

export function address(value, { buyer = {} }) {
  const addressErrors = {};
  let requiredFields = foreignAddressRequiredFields;

  if (!buyer.foreign) {
    addressErrors.postalCode = postalCode(value && value.postalCode);
    requiredFields = addressRequiredFields;
  }

  let addressHasError = false;

  requiredFields.forEach(field => {
    const error = required(value && value[field]);

    if (error) {
      addressHasError = true;
      addressErrors[field] = error;
    }
  });

  return addressHasError ? addressErrors : undefined;
}

export function postalCode(value) {
  return !value || postalCodeRegex.test(value) ? (
    undefined
  ) : (
    <FormattedMessage id="invalidPostalCode" />
  );
}

export function email(value) {
  return !value || emailRegex.test(value) ? undefined : <FormattedMessage id="invalidEmail" />;
}

export function phone(value) {
  return !value || phoneRegex.test(value) ? undefined : <FormattedMessage id="invalidPhone" />;
}

export function date(value = '') {
  return !value || moment(value, 'DD/MM/YY', true).isValid() ? (
    undefined
  ) : (
    <FormattedMessage id="invalidDate" />
  );
}

export function cpf(value) {
  return !value || validateCPF(value) ? undefined : <FormattedMessage id="invalidDocument" />;
}

export function cnpj(value) {
  return !value || validateCNPJ(value) ? undefined : <FormattedMessage id="invalidDocument" />;
}

export function participantDocument(value) {
  return !value || validateCPF(value) || validateCNPJ(value) ? (
    undefined
  ) : (
    <FormattedMessage id="invalidDocument" />
  );
}

function validateCPF(value) {
  const originalCPF = value.toString().replace(/[^0-9]/g, '');
  const cpf = calculateDigitsPositions(calculateDigitsPositions(originalCPF.substr(0, 9)), 11);
  return cpf === originalCPF;
}

function validateCNPJ(value) {
  const originalCNPJ = value.toString().replace(/[^0-9]/g, '');
  const cnpj = calculateDigitsPositions(calculateDigitsPositions(originalCNPJ.substr(0, 12), 5), 6);
  return cnpj === originalCNPJ;
}

function calculateDigitsPositions(digits, position = 10, sum = 0) {
  digits = digits.toString();
  if (equalNumbersRegex.test(digits)) {
    return false;
  }
  for (let i = 0; i < digits.length; i++) {
    sum = sum + digits[i] * position;
    position--;
    if (position < 2) {
      position = 9;
    }
  }
  sum = sum % 11;
  if (sum < 2) {
    sum = 0;
  } else {
    sum = 11 - sum;
  }
  return digits + sum;
}



// WEBPACK FOOTER //
// ./src/site-render/src/lib/validate.js